export const apiEndpoints = {
  loginUrl: `user/auth/login`,
  signUrl: `user/auth/signup`,
  forgetUrl: 'user/auth/forgot_password',
  otpVerifyUrl: 'user/auth/verify_otp',
  resendOtpUrl: 'user/auth/resend_otp',
  changePasswordUrl: 'user/auth/change_password',
  resetPasswordUrl: 'user/auth/reset_password',
  profileUrl: 'user/auth/details',
  commonContentUrl: 'common/common_content',
  commonContentUpdateUrl: 'admin/common/common_content',
  userGetUrl: 'admin/user/list',
  userDetailsUrl: 'user/user/details',
  userStatusUrl: 'admin/user/status',
  userDashboardUrl: '/user/auth/details',
  cltDataUrl: '/happcoach/get_happcoach_clt',
  getCompanyUrl: '/happcoach/get_happcoach_company_list',
  getCompanyDetailUrl: 'company/detail',
  addCompanyUrl: 'company/add_company_details',
  addDetailCompanyUrl: 'company/add_employee_division',
  imageUploadUrl: 'common/upload_file',
  updatePassword: 'user/auth/change_password',
  updateAdmin: 'user/auth/profile',
  getProfileData: 'user/auth/details',
  getDashboardUrl: 'admin/auth/dashboard_count',
  getCompanyListing: 'company/listing_admin',
  addCompanyDivision: 'company/add_division_details',
  updateCompanyStatus: 'company/update_company_details',
  getDeptListUrl: 'department/listing_department_division',
  getDashboardGraphUrl: 'happcoach/get_company_employee_count',
  divisionDetailByIdUrl: 'happcoach/detail_company_happcoach_divsion',
  messageGetUrl: 'happcoach/get_happcoach_member',
  updateChatFileUrl: "common/upload_chat_files",
  userAssignedUrl:"happcoach/happcoach_assign_user_list",
  assignedMemberByIdUrl:"happcoach/action_count_user",
  happcoachCompanyGraphInfo:"happcoach/HappcoachCompanyGraphInfo",
  userActionUrl:"",
  userActionList:"Hc/action_count_users_admin",
  divisionDepartmentList:"common/get_all_departments",
  getUserDropdownById: "happcoach/getUserDropdown",
  getCommonHCList: "Hc/hc_list_by_type",
  getMemberDetails: "happcoach/getMemberDetail"
}
